export default function getSupplierName(supplier) {
    if(supplier === 'AMADEUS_LOS_2')
      return 'Amadeus LOSN8210G'
    else if(supplier === 'AMADEUS_LOS_3')
      return 'Amadeus LOSN82100'
    else if(supplier === 'AMADEUS')
      return 'Amadeus LOSN828HR'
  
    return supplier;
  }